export const DICTIONARY_LIST_PATH = "/settings-menu/dictionaries";
